// extracted by mini-css-extract-plugin
export default {"topLines":"TopLines_topLines__7YrUr","line1":"TopLines_line1__DeJxu","line2":"TopLines_line2__eqB1t"};